import { render, staticRenderFns } from "./foodsponsor.vue?vue&type=template&id=32499031&"
import script from "./foodsponsor.vue?vue&type=script&lang=js&"
export * from "./foodsponsor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports